/**
 * Pages of the promo site (riselio.com, built from docs/promo-site/src). The home and contact
 * pages exist in every app language (T-163); the legal texts in Turkish and English only, so the
 * other languages get the English ones. English keeps its historical file names at the root; the
 * unprefixed /privacy-policy.html, /terms.html and /contact.html redirect to Turkish.
 */
export type SitePage = 'home' | 'contact' | 'privacy' | 'terms';

const SITE = 'https://riselio.com';

/** Languages with their own home and contact pages besides English (docs/promo-site/src/locales). */
const SITE_LANGUAGES = ['tr', 'de', 'es', 'fr', 'ru', 'uk', 'ar', 'fa'];

const LEGAL = { tr: { privacy: '/tr/privacy-policy.html', terms: '/tr/terms.html' }, en: { privacy: '/privacy-policy-en.html', terms: '/terms-en.html' } };

/** URL of a promo site page in the given UI language. */
export const sitePageUrl = (page: SitePage, language: string): string => {
  const english = !SITE_LANGUAGES.includes(language);
  switch (page) {
    case 'home':
      return english ? `${SITE}/` : `${SITE}/${language}/`;
    case 'contact':
      return english ? `${SITE}/contact-en.html` : `${SITE}/${language}/contact.html`;
    default:
      return SITE + LEGAL[language === 'tr' ? 'tr' : 'en'][page];
  }
};
